import React from 'react';
import { VerifyPasswordOrPin } from '../../components/Forms/VerifyPasswordOrPin';
import { Home } from './Home';

export const VerifyPinOrPasswordPage = () => <Home><VerifyPasswordOrPin /></Home>;
